// extracted by mini-css-extract-plugin
export default {"recos":"a8-z","productCardOverride":"b8-z","rowHasBadge":"c8-z"};